import axios from 'axios';

export const url = "https://memberadmin.tga.or.th/api"

const fetchCouse = (search, page) => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/list/course`, {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                search: search,
                page: page
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const fetchTeeoff = (courseCode) => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/course/detail`, {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                course_code: courseCode,
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const fetchMemberList = (page, language, search) => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/member/list`, {
            params: {
                page: page,
                language: language,
                search: search
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const historyScore = (memberCode, page) => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/history/score`, {
            params: {
                member_code: memberCode,
                page: page,
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const historyYear = (memberCode) => {
    return axios.post(`${url}/history/year`, {
        params: {
            member_code: memberCode,
        }
    })
}

const getScore = (memberCode, id) => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/get/score`, {
            params: {
                id: id,
                member_code: memberCode
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const tournamentCategory = () => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/tournament_category`, {
            params: {
                "jsonrpc": "2.0"
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const tournament = (technical_name) => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/tournament`, {
            params: {
                "jsonrpc": "2.0",
                "technical_name": technical_name
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const news = (page, search) => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/news`, {
            params: {
                "jsonrpc": "2.0",
                page:page,
                search:search
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const newsPopular = () => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/news/popular`, {
            params: {
                "jsonrpc": "2.0",
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const newsDetail = (id) => {
    return new Promise(async function (resolve, reject) {
        axios.post(`${url}/news/${id}/content`, {
            params: {
                "jsonrpc": "2.0",
            }
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const weather = (province) => {
    return new Promise(async function (resolve, reject) {
        const lang = localStorage.getItem('i18nextLng')

        axios.get(`https://api.openweathermap.org/data/2.5/forecast?q=${province},THA&units=metric&lang=${lang}&appid=41959808df36dafcff1456305b4c1d32`, {}).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const statistic = (member_code, fromDate, toDate) => {
    return axios.post(`${url}/score/statistic`, {
        jsonrpc: 2.0,
        params: {
            member_code: member_code,
            from_date: fromDate,
            to_date: toDate,
        }
    })
}

const httpRequest = {
    fetchCouse,
    fetchTeeoff,
    fetchMemberList,
    historyScore,
    historyYear,
    getScore,
    tournamentCategory,
    tournament,
    news,
    newsDetail,
    newsPopular,
    weather,
    statistic
}
export default httpRequest
